import { Button, ButtonProps } from '@mui/material';

interface SettingProps {
    className?: string, onClickCallback?: () => void, onNavigate?: () => void, title: string,
    label: string, icon: JSX.Element, height?: number, color?: ButtonProps['color']
}

const NavButton = ({ className, onClickCallback, onNavigate, title, icon, label, height, color }: SettingProps): JSX.Element => {
    return (
        <Button variant="contained" color={color ?? "primary"} className={`${className ?? ''} navActionButton`} style={{ height: height ?? 40 }}
            title={title}
            onClick={() => {
                if (onClickCallback) onClickCallback();
                if (onNavigate) setTimeout(() => onNavigate(), 0);
            }}>
            <span className="navButtonText">
                {icon}
                {label}
            </span>
        </Button>
    )
};

export default NavButton;
